<div class="container-fluid" style="margin-top: 70px">
    <h5 class="section-header">TIMETABLE</h5><p class="mt-3"></p>
    <div class="custom-card">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Day/Time</th><th *ngFor="let day of days">{{ day.day }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let d of display">
                    <td>{{ d.start_time + " - " + d.end_time }}</td>
                    <td *ngFor="let p of d.days">
                        {{ p.course_title | uppercase }}<small style="font-size: 0.6em">{{ p.venue }}</small>
                    </td>
                </tr>
            </tbody>
        </table>


    </div>
</div>
